import { doc, getDoc } from "firebase/firestore";
import exampleBackground1 from "../assets/exBackground1.jpg";
import exampleBackground2 from "../assets/exBackground2.jpg";
import exampleBackground3 from "../assets/exBackground3.jpg";
import exampleBackground4 from "../assets/exBackground4.jpg";
import exampleBackground5 from "../assets/exBackground5.jpg";

export const STANDARD_PROFILE_BACKGROUNDS_CONFIG = {
  collection: "config",
  id: "myTasselPlus",
  field: "standardProfileBackgrounds",
  storagePath: "mytasselPlus/standardProfileBackgrounds",
};

const BUILTIN_BACKGROUND_SOURCES = {
  "builtin:exBackground1": exampleBackground1,
  "builtin:exBackground2": exampleBackground2,
  "builtin:exBackground3": exampleBackground3,
  "builtin:exBackground4": exampleBackground4,
  "builtin:exBackground5": exampleBackground5,
};

export const FALLBACK_STANDARD_PROFILE_BACKGROUNDS = [
  { id: "exBackground1", label: "Background 1", imageUrl: "builtin:exBackground1", active: true, availableToStandard: true, availableToPlus: true, order: 0, fallback: true },
  { id: "exBackground2", label: "Background 2", imageUrl: "builtin:exBackground2", active: true, availableToStandard: true, availableToPlus: true, order: 1, fallback: true },
  { id: "exBackground3", label: "Background 3", imageUrl: "builtin:exBackground3", active: true, availableToStandard: true, availableToPlus: true, order: 2, fallback: true },
  { id: "exBackground4", label: "Background 4", imageUrl: "builtin:exBackground4", active: true, availableToStandard: true, availableToPlus: true, order: 3, fallback: true },
  { id: "exBackground5", label: "Background 5", imageUrl: "builtin:exBackground5", active: true, availableToStandard: true, availableToPlus: true, order: 4, fallback: true },
];

export const readBackgroundBoolean = (background, field, defaultValue = true) => {
  if (!background || !Object.prototype.hasOwnProperty.call(background, field)) {
    return defaultValue;
  }

  const value = background[field];
  if (value === false || value === "false") return false;
  if (value === true || value === "true") return true;
  return defaultValue;
};

export const normalizeStandardProfileBackgrounds = (backgrounds = [], options = {}) => (
  backgrounds
    .map((background, index) => {
      const defaultStandardAvailability =
        typeof options.defaultStandardAvailability === "function"
          ? options.defaultStandardAvailability(background, index)
          : options.defaultStandardAvailability;

      return {
        id: String(background.id || `standard-${index + 1}`),
        label: String(background.label || `Background ${index + 1}`),
        imageUrl: background.imageUrl || background.url || "",
        storagePath: background.storagePath || "",
        source: background.source,
        active: readBackgroundBoolean(background, "active", true),
        availableToStandard: readBackgroundBoolean(
          background,
          "availableToStandard",
          defaultStandardAvailability ?? true
        ),
        availableToPlus: readBackgroundBoolean(background, "availableToPlus", true),
        order: Number.isFinite(Number(background.order)) ? Number(background.order) : index,
        fallback: Boolean(background.fallback),
      };
    })
    .filter((background) => (options.includeInactive || background.active) && (background.imageUrl || background.source))
    .sort((a, b) => a.order - b.order)
);

export const filterProfileBackgroundsForTier = (backgrounds = [], hasPlus = false) => {
  const tierFiltered = normalizeStandardProfileBackgrounds(backgrounds).filter((background) => (
    hasPlus ? background.availableToPlus !== false : background.availableToStandard !== false
  ));

  return hasPlus ? tierFiltered : tierFiltered.slice(0, 5);
};

export const loadStandardProfileBackgrounds = async (db) => {
  try {
    const configSnap = await getDoc(doc(
      db,
      STANDARD_PROFILE_BACKGROUNDS_CONFIG.collection,
      STANDARD_PROFILE_BACKGROUNDS_CONFIG.id
    ));

    if (configSnap.exists()) {
      const configured = normalizeStandardProfileBackgrounds(
        configSnap.data()?.[STANDARD_PROFILE_BACKGROUNDS_CONFIG.field] || []
      );
      if (configured.length > 0) return configured;
    }
  } catch (error) {
    // Fall back silently so settings never disappear because config is missing.
  }

  return FALLBACK_STANDARD_PROFILE_BACKGROUNDS;
};

export const getStandardProfileBackgroundValue = (background) => (
  BUILTIN_BACKGROUND_SOURCES[background?.imageUrl] || background?.imageUrl || background?.source || null
);

export const getImageSource = (value) => {
  if (!value) return null;
  return typeof value === "string" ? { uri: value } : value;
};
